import styled from "styled-components";
import { ZingTheme } from '../../../../../../shared/src/assets/theme/types'

export const HotsitePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const HotsiteContentWrapper = styled.div`
  flex: 1 0 auto;
  min-width: 0;
  background-color: ${({ theme }) => (theme as ZingTheme).colors.purple50};
`;

export const FixedPageTopWrapper = styled.div<{ $isSidebarOpen: boolean }>`
  position: fixed;
  top: 0;
  left: ${({ $isSidebarOpen }) => ($isSidebarOpen ? "255px" : "100px")};
  width: calc(100% - ${({ $isSidebarOpen }) => ($isSidebarOpen ? "255px" : "100px")});
  z-index: 51;

  @media screen and (max-width: 576px) {
    left: 0;
    width: 100%;
  }
`;

export const NotFoundWrapper = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100vh;
`;

export const NotFoundPageTitle = styled.h4`
  font-size: 2.5rem;
`;

export const NotFoundPageDescription = styled.p`
  font-size: 1.25rem;
  margin-bottom: 1.5rem;
`;
